<template>
  <div>
    <div class="y-header" id="header">
      <router-link tag="div" to="/navigation" class="header-menu">
        <img src="../../assets/images/1.png" alt>
      </router-link>
      <div class="header-logo">
        <img src="../../assets/images/2.png" alt>
      </div>
      <div class="header-close" @click="$router.back(-1)" v-if="isClose">
        <img src="../../assets/images/close.png" alt>
      </div>
    </div>
    <div class="empty"></div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isClose: false
    };
  },
  methods: {},
  created() {
    if (this.$route.fullPath == "/navigation") {
      this.isClose = true;
    }
  },
  mounted() {

         //通过navigator加正则判断区别手机端和pc端；
	   var reg = /([a-zA-Z]+)?([a-zA-Z]+.*\;\s([a-zA-Z0-9]+)?)/
	   var newNav = navigator.appVersion.match(reg);
	   if(newNav){
	   	 var nav = newNav[0];
	   	 var navArr = nav.split(/(\s)|((\s\d\.\d)?\;)/);
	   	 var flag = false;
	   	 for(var i = 0,len=navArr.length;i<len;i++){
	   	 	if (navArr[i]=='Android'||navArr[i]=='iPhone'||navArr[i]=='iPad'||navArr[i]=='MeeGo'||navArr[i]=='NokiaN9'||navArr[i]=='NOKIA') {
	   	 		flag = true;
	   	 		break;
	   	 	}

	   	 }
	   	 if (flag) {
          // console.log('我用了手机');
          let header = document.querySelector('.y-header');
          header.style.position = 'fixed';
	   	 }
	   	 else{
          // console.log('我用了pc端');
          document.body.style.width = '980px'
	   	 }
	   }
  },
};
</script>
<style lang="less">
.empty {
  height: 103px;
  overflow: hidden;
}
.y-header {
  z-index: 999;
  // position: fixed;
  position: relative;
  width: 100%;
  top: 0;
  left: 0;
  height: 103px;
  box-sizing: border-box;
  padding: 17px 47px 7px 47px;
  background: #fff;
  display: flex;
  .header-menu {
    flex: 1 45%;
    margin-top: 17px;
    margin-bottom: 16px;
    img {
      width: 54px;
      height: 35px;
    }
  }
  .header-logo {
    flex: 1 55%;
    img {
      width: 127px;
      height: 67px;
    }
  }
  .header-close {
    width: 40px;
    margin-top: 17px;
    img {
      width: 40px;
      height: 40px;
    }
  }
  .navigat {
    height: 100%;
    padding: 241px;
    background: #f8f6f4;
    .nav-main {
      margin: 241px auto;
      text-align: center;
      li {
        height: 27px;
        font-size: 29px;
        font-family: SourceHanSansCN-Light;
        font-weight: 300;
        color: rgba(89, 87, 87, 1);
        margin-bottom: 60px;
      }
    }
  }
}
@media screen and (min-width: 980px) {
  .y-header {
    width: 100%;
    left: 50%;
    transform: translateX(-575px);
  }
}
</style>
